import React, { useState, useEffect } from "react";
import { Heading, Flex, Text, Container } from "@chakra-ui/react";

import { load_favourite_candidates } from "@lib/datahandlers/company";
import Layout from "@pages/Layout";
import { Separator, CandidateItem, View, LoadMore, CustomSkeleton } from "@components";
import { PER_PAGE } from "@lib/constants";

import { t } from "@lang/i18n";

const Favourites = () => {
  const initStateLoadMore = { 
    page: 1, 
    has_more: "", 
    loading_more: "" 
  };

  const [favouriteCandidates, setFavouriteCandidates] = useState([]);
  const [loadMore, setLoadMore] = useState(initStateLoadMore);
  const [isLoaded, setIsLoaded] = useState(false);

  // check if array is empty or not
  const isArrayEmpty = (arr) => {
    if (arr.length > 0) return false;
    return true;
  };

  // load favourite favourites
  const onLoad = async () => {
    try {
      setIsLoaded(true);
      const searchQuery =  `/persons/liked?page=1`;
      const result = await load_favourite_candidates(searchQuery);
      if (result.success) {
        setFavouriteCandidates(result.data);
        setLoadMore({
          ...loadMore,
          has_more: result.data.length === PER_PAGE,
        })
        setIsLoaded(false);
        return;
      }
    } catch (err) {
      console.log("Error: ", err);
    }
  };
  // load more favourites
  const showMore = async () => {
      let nextPage = loadMore.page + 1;
      const searchQuery =  `/persons/liked?page=${nextPage}`;

      setLoadMore({...loadMore, loading_more: true})
      const result = await await load_favourite_candidates(searchQuery);
      setLoadMore({...loadMore, loading_more: false})

      if(result.success) {
        
        setLoadMore({
          ...loadMore,
          has_more: result.data.length === PER_PAGE,
          page: nextPage,
        });
        setFavouriteCandidates([...favouriteCandidates, ...result.data]);
      }
      // else toast({description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000});
  };

  useEffect(() => {
    if (isArrayEmpty(favouriteCandidates)) {
      onLoad();
    }
  }, []);

  return (
    <Layout menuType="company" isNavBarVisible isFooterVisible>
      <Container maxW="1024px" bg="white" minHeight='calc(100vh - 100px)' py="36px" px={["16px","","","100px"]} borderRadius="4px">
        <Flex flexDir="column">
          
          <Heading as="h1" fontSize="30px" color="black" textAlign="center">
            {t("company.favourite_candidates.title")}
          </Heading>

          <Separator />

          <Flex flexDir="column" justifyContent="center">
            <Text fontWeight="600" fontSize="1rem" textAlign="left">
              {favouriteCandidates.length > 0 &&
                t("company.favourite_candidates.description")}
            </Text>

            {/* skeleton loading */}
            <View if={isLoaded} display="flex" flexDir="row" flexWrap="wrap" justifyContent={{base: "center", lg: "space-between"}}>
              <CustomSkeleton type="FETCH_ITEMS" />
              <CustomSkeleton type="FETCH_ITEMS" />
              <CustomSkeleton type="FETCH_ITEMS" />
            </View>
    
            {/* fetch favourites */}
            <View if={!isLoaded && favouriteCandidates.length > 0} mt="24px">
                <Flex flexDir="row" justifyContent={{base: "center", lg: "space-between"}} flexWrap="wrap">
                  {favouriteCandidates.map((el) => 
                      <CandidateItem data={el} iconType="company" id={el.id}
                        favouriteCandidates={favouriteCandidates}
                        setFavouriteCandidates={setFavouriteCandidates}
                      />
                    )}
                </Flex>
            </View>

            {/* favourites none */}
            <View if={!favouriteCandidates.length > 0}>
                <Text color="gray.borders" fontWeight="600" fontSize="1.25rem"  mt="10rem" textAlign="center">
                  {t("company.favourite_candidates.favourites_none")}
                </Text>
            </View>

            {/* Pagination */}
            <View if={loadMore.has_more} flexBasis="100%" textAlign="center">
              <LoadMore showMore={showMore} loading_more={loadMore.loading_more} />
            </View>
          </Flex>
        </Flex>
      </Container>
    </Layout>
  );
};

export default Favourites;
